import { IPaidPersonalLeaveRequestData } from "./PaidPersonalLeaveRequestData";

export const defaultData: IPaidPersonalLeaveRequestData = {
  message: '',
  isSuccess: true,
  employeeInfo: {
    employeeFirstName: "",
    employeeLastName: "",
    employeeNumber: null,
    employeePhoneNumber: "",
    employeeTypeCode: "",
    employeeClassCode: "",
    employeeStatusCode: "",
    employeeBoardCode: "",
    employeeHomePortCode: "",
    employeeEmail: "",
    employeeLocalCode: "",
    employeeLocalDescription: "",
    WIApproved: null, //default to unselected
    unpaidMedicalLeaveApproved: null, // default to unselected
    reasonForLeave: "", // Default text
    regularWorkforce: null, //default to unselected
    regularWorkforceDetail: "",
    eligibleToWork: null, // default to unselected
    eligibleToWorkDetail: "",
    workRestriction: null, //default to unselected
    workRestrictionDetail: "",
    dispatchedToWork: null, //default to unselected
    dispatchedToWorkDetail: "",
    requestedDateFrom: '',
    requestedDateTo: '',
    numberOfDaysRequested: 0,
    attachments: [],
    certifyStatus: false,
  }
}

export enum ProgressBarSteps {
  PersonalInfo = "Personal Info",
  LeaveDetails = "Leave Details",
  DaysRequested = "Days Requested",
  Confirmation = "Confirmation"
}

export interface IDisclaimer {
  title?: string;
  text?: Array<string | JSX.Element>,
  bulletParagraph?: boolean
}

export const defaultDisclaimer = { title: '', text: [] };

export const MAX_ATTACHMENTS = 5;
